import elrondApiHelper from "@/helpers/elrondApi";
import SHUTDOWN from "@/constants/shutdown";

export const SHUTDOWN_GETTERS = {
  TX_COUNT: "shutdownTxCount",
  LOADED: "shutdownLoaded",
  DEADLINE: "shutdownDeadline",
  IS_SHUT_DOWN: "shutdownIsShutDown",
};

export const SHUTDOWN_MUTATIONS = {
  TX_COUNT: "shutdownTxCount",
};

export const SHUTDOWN_ACTIONS = {
  REFRESH: "shutdownRefresh",
};

interface SHUTDOWN_STORE_STATE {
  txCount: number | null;
}

export const shutdownStore = {
  state: (): SHUTDOWN_STORE_STATE => ({
    txCount: null,
  }),
  getters: {
    [SHUTDOWN_GETTERS.TX_COUNT](state) {
      return state.txCount;
    },
    [SHUTDOWN_GETTERS.LOADED](state) {
      return null !== state.txCount;
    },
    // Absolute unix timestamp (seconds) at which the site goes dark, or null until first loaded.
    [SHUTDOWN_GETTERS.DEADLINE](state) {
      if (null === state.txCount) {
        return null;
      }

      return (
        SHUTDOWN.GENESIS_TIMESTAMP +
        SHUTDOWN.BASE_DAYS * SHUTDOWN.DAY_SECONDS +
        state.txCount * SHUTDOWN.BONUS_HOURS_PER_TRANSACTION * SHUTDOWN.HOUR_SECONDS
      );
    },
    [SHUTDOWN_GETTERS.IS_SHUT_DOWN](state, getters) {
      const deadline = getters[SHUTDOWN_GETTERS.DEADLINE];

      if (null === deadline) {
        return false;
      }

      return Math.floor(Date.now() / 1000) >= deadline;
    },
  },
  mutations: {
    [SHUTDOWN_MUTATIONS.TX_COUNT](state, txCount) {
      state.txCount = txCount;
    },
  },
  actions: {
    async [SHUTDOWN_ACTIONS.REFRESH]({ commit }) {
      try {
        const txCount = await elrondApiHelper.getTransactionsCountToProxy(SHUTDOWN.GENESIS_TIMESTAMP);

        commit(SHUTDOWN_MUTATIONS.TX_COUNT, txCount);
      } catch (e) {
        // Keep whatever value we already had (or null pre-first-load); never let a transient
        // network failure make the site look shut down.
        console.error(e);
      }
    },
  },
};
